import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import {
  type SubmitLoanMutationVariables,
  SubmitLoanDocument,
  FinancingDocument,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';

const useSubmitLoan = () => {
  const [submitLoanMutation] = useMutation(SubmitLoanDocument);

  const submitLoan = useCallback(
    async ({ projectId, formData }: SubmitLoanMutationVariables) => {
      try {
        await submitLoanMutation({
          variables: { projectId, formData },
          refetchQueries: [{ query: FinancingDocument, variables: { id: projectId } }],
          awaitRefetchQueries: true,
        });
      } catch (error) {
        throw withRaw(toGraphqlError(error), error || '');
      }
    },
    [submitLoanMutation],
  );
  return submitLoan;
};

export default useSubmitLoan;
